"use client";
import ProducrCard from "@/components/Product/product-card";
import { ProductListItemFragment } from "@/gql/graphql";
import { Empty, message, Spin } from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { fetchProductByCategoryData, fetchProductData } from "@/lib/api/product";
import { Button } from "../Button";
import { log } from "console";

const ProductList = ({
	products,
	locale,
	channel,
	slug,
}: {
	products: any;
	locale: string;
	channel: string;
	slug?: string;
}) => {
	// 每页显示的产品数量
	const PAGE_SIZE = 9;

	// 搜索页面无loadmore ==> ?
	const [hasMore, setHasMore] = useState(products?.pageInfo?.hasNextPage);
	const [moreLoading, setMoreLoading] = useState(false);
	const [after, setAfter] = useState(products?.pageInfo?.endCursor);
	const [productsList, setProductsList] = useState(products);
	// 当前显示的产品数量
	const [displayCount, setDisplayCount] = useState(PAGE_SIZE);

	useEffect(() => {
		console.log("this is products ", products);
	}, [products]);

	const onLoadMore = useCallback(async () => {
		// 如果当前显示的产品数量小于总产品数量，则显示更多本地产品
		if (displayCount < productsList.edges.length) {
			setDisplayCount((prev) => Math.min(prev + PAGE_SIZE, productsList.edges.length));
			return;
		}

		// 否则从服务器加载更多产品
		try {
			setMoreLoading(true);
			let res = null;
			if (slug) {
				res = (await fetchProductByCategoryData({ slug, locale, channel, after }))?.category;
			} else {
				res = await fetchProductData({ locale, channel, after });
			}

			setProductsList((prev) => ({
				...prev,
				edges: [...prev.edges, ...res.products.edges],
			}));

			// 更新显示数量
			setDisplayCount((prev) => prev + Math.min(PAGE_SIZE, res.products.edges.length));
			setHasMore(res.products.pageInfo.hasNextPage);
			setAfter(res.products.pageInfo.endCursor);
		} catch (e) {
			message.error(e.message);
		} finally {
			setMoreLoading(false);
		}
	}, [locale, channel, after, displayCount, productsList.edges.length]);

	// 获取当前应该显示的产品
	const visibleProducts = productsList?.edges.slice(0, displayCount);

	// 判断是否还有更多产品可以加载
	const hasMoreToShow = displayCount < productsList?.edges.length || hasMore;

	return (
		<>
			{!productsList?.edges.length && <Empty />}
			<div className="mt-11 grid grid-cols-3 gap-x-3 gap-y-14 max-lg:grid-cols-2 max-md:grid-cols-1 max-md:gap-y-4">
				{visibleProducts.map((item) => (
					<ProducrCard
						key={item.node.slug}
						productItem={item.node as ProductListItemFragment}
						locale={locale}
					/>
				))}
			</div>
			{moreLoading ? (
				<Spin />
			) : (
				hasMoreToShow && (
					<div className="mt-6 flex justify-center">
						<Button onClick={onLoadMore} className="rounded-md">
							Load More
						</Button>
					</div>
				)
			)}
		</>
	);
};

export default ProductList;
